export const UPDATE_PRODUCT = 'UPDATE_PRODUCT';
export const ADD_PRODUCT = 'ADD_PRODUCT';
export const CHANGE_PRODUCT = 'CHANGE_PRODUCT';
export const COPY_PROPERTIES = 'COPY_PROPERTIES';
export const SET_PRODUCT = 'SET_PRODUCT';
export const SET_API_PRODUCT = 'SET_API_PRODUCT';
export const SET_PRODUCT_SCHEDULES = 'SET_PRODUCT_SCHEDULES';
export const SET_PRODUCT_SCHEDULE = 'SET_PRODUCT_SCHEDULE';
export const ADD_PRODUCT_SCHEDULE = 'ADD_PRODUCT_SCHEDULE';
export const SET_DURATION_ENABLED_FLAG = 'SET_DURATION_ENABLED_FLAG';
export const SET_LEGACY_VARIANT_TIMES_FLAG = 'SET_LEGACY_VARIANT_TIMES_FLAG';
export const SET_VARIANT_OPTIONS = 'SET_VARIANT_OPTIONS';
export const SET_PRODUCT_TERM_EVENTS = 'SET_PRODUCT_TERM_EVENTS';
export const SET_PRODUCT_LOADING = 'SET_PRODUCT_LOADING';
export const SET_PRODUCT_TERM = 'SET_PRODUCT_TERM';
export const ADD_TERM = 'ADD_TERM';
export const SET_PROFILE_OPTIONS = 'SET_PROFILE_OPTIONS';
export const SET_RESOURCE_OPTIONS = 'SET_RESOURCE_OPTIONS';
export const SET_LOCATION_OPTIONS = 'SET_LOCATION_OPTIONS';
export const SET_AVAILABLE_LOCATIONS = 'SET_AVAILABLE_LOCATIONS';
export const SET_COLOR_OPTIONS = 'SET_COLOR_OPTIONS';
export const SET_DURATION_UNIT_OPTIONS = 'SET_DURATION_UNIT_OPTIONS';
export const SET_RANGE_COUNT_BASIS_OPTIONS = 'SET_RANGE_COUNT_BASIS_OPTIONS';
export const SET_CAPACITY_OPTIONS = 'SET_CAPACITY_OPTIONS';
export const SET_FOO = 'FOO';
export const SET_PRODUCT_PROFILE = 'SET_PRODUCT_PROFILE';
export const SET_DURATION_OPTIONS = 'SET_DURATION_OPTIONS';
export const SET_OPTION_CAPACITY = 'SET_OPTION_CAPACITY';
export const SET_PRODUCT_DURATION_OPTION = 'SET_PRODUCT_DURATION_OPTION';
export const SET_PRODUCT_VARIANT_OPTION_DURATIONS = 'SET_PRODUCT_VARIANT_OPTION_DURATIONS';
export const SET_PRODUCT_VARIANT_OPTION_DURATION = 'SET_PRODUCT_VARIANT_OPTION_DURATION';
export const SET_PRODUCT_DURATION_TYPE = 'SET_PRODUCT_DURATION_TYPE';
export const SET_PRODUCT_ERRORS = 'SET_PRODUCT_ERRORS';
export const SET_PRODUCT_MODIFIED = 'SET_PRODUCT_MODIFIED';
export const SET_OPTION_CAPACITIES_ATTRIBUTES = 'SET_OPTION_CAPACITIES_ATTRIBUTES';
export const CAPACITY_OPTION_ENABLE = 'CAPACITY_OPTION_ENABLE';
export const PRODUCT_SUBMITTED = 'PRODUCT_SUBMITTED';
export const SET_VISIBLE_IN_CALENDAR = 'SET_VISIBLE_IN_CALENDAR';
export const CHANGE_CAPACITY_TYPE = 'CHANGE_CAPACITY_TYPE';
export const SET_ACTIVITY_DURATION_VARIANTS_ENABLED_FLAG = 'SET_ACTIVITY_DURATION_VARIANTS_ENABLED_FLAG';
export const INIT_PRODUCT = 'INIT_PRODUCT';
export const SET_API_BOOKING = 'SET_API_BOOKING';
export const SET_INPUT_FEEDS = 'SET_INPUT_FEEDS';
export const SET_INPUT_FEED = 'SET_INPUT_FEED'
export const ADD_INPUT_FEED = 'ADD_INPUT_FEED';
export const DELETE_INPUT_FEED = 'DELETE_INPUT_FEED';
export const SET_INPUT_FEED_NAME = 'SET_INPUT_FEED_NAME';
export const SET_INPUT_FEED_URL = 'SET_INPUT_FEED_URL';
export const SET_INPUT_FEEDS_VALIDATION_ERRORS = 'SET_INPUT_FEEDS_VALIDATION_ERRORS';
export const SET_SEASONAL_RATES_VALIDATION_ERRORS = 'SET_SEASONAL_RATES_VALIDATION_ERRORS';
export const CHANGE_PRODUCT_ERRORS = 'CHANGE_PRODUCT_ERRORS';
export const CHANGE_PRODUCT_HAS_SEASONAL_RATES = 'CHANGE_PRODUCT_HAS_SEASONAL_RATES';
export const CHANGE_PRODUCT_SEASON_OPTION_NAME = 'CHANGE_PRODUCT_SEASON_OPTION_NAME';
export const CHANGE_PRODUCT_SEASON_OPTION_VALUES = 'CHANGE_PRODUCT_SEASON_OPTION_VALUES';
export const CHANGE_PRODUCT_RATE_OPTION_NAME = 'CHANGE_PRODUCT_RATE_OPTION_NAME';
export const CHANGE_PRODUCT_RATE_OPTION_VALUES = 'CHANGE_PRODUCT_RATE_OPTION_VALUES';
export const SET_EDIT_SEASONAL_RATES = 'SET_EDIT_SEASONAL_RATES';
export const ADD_SEASONAL_RATE = 'ADD_SEASONAL_RATE';
export const DELETE_SEASONAL_RATES = 'DELETE_SEASONAL_RATES';
export const SET_SEASONAL_RATE_PRICE = 'SET_SEASONAL_RATE_PRICE';
export const SET_SEASONAL_RATE_STARTS_AT = 'SET_SEASONAL_RATE_STARTS_AT';
export const SET_SEASONAL_RATE_FINISHES_AT = 'SET_SEASONAL_RATE_FINISHES_AT';

export const CAPACITY_TYPE = { product: 0, variants: 1, resources: 2 };

export function onProductErrorsSet(errors) {
  return {
    type: SET_PRODUCT_ERRORS,
    errors,
  };
}

export function onOptionCapacitySet(index, value) {
  return {
    type: SET_OPTION_CAPACITY,
    index,
    value,
  };
}

export function onProfileOptionsSet(options) {
  return {
    type: SET_PROFILE_OPTIONS,
    options,
  };
}
export function onResourceOptionsSet(options) {
  return {
    type: SET_RESOURCE_OPTIONS,
    options,
  };
}
export function onLocationOptionsSet(options) {
  return {
    type: SET_LOCATION_OPTIONS,
    options,
  };
}

export function onAvailableLocationsSet(options) {
  return {
    type: SET_AVAILABLE_LOCATIONS,
    options,
  };
}

export function onColorOptionsSet(options) {
  return {
    type: SET_COLOR_OPTIONS,
    options,
  };
}
export function onDurationUnitOptionsSet(options) {
  return {
    type: SET_DURATION_UNIT_OPTIONS,
    options,
  };
}
export function onRangeCountBasisOptionsSet(options) {
  return {
    type: SET_RANGE_COUNT_BASIS_OPTIONS,
    options,
  };
}
export function onProductModifiedSet() {
  return {
    type: SET_PRODUCT_MODIFIED,
  };
}
export function onCapacityOptionsSet(options) {
  return {
    type: SET_CAPACITY_OPTIONS,
    options,
  };
}
export function onDurationOptionsSet(options) {
  return {
    type: SET_DURATION_OPTIONS,
    options,
  };
}
export function onVariantOptionsSet(options) {
  return {
    type: SET_VARIANT_OPTIONS,
    options,
  };
}
export function onProfileSet(profile) {
  return (dispatch) => {
    dispatch({ type: SET_PRODUCT_PROFILE, value: profile });
  };
}

export function onRangeCountBasisSet(count) {
  return (dispatch) => {
    dispatch({ type: CHANGE_PRODUCT, name: 'range_count_basis', value: count });
  };
}

export function onWidgetIdSet(value) {
  return (dispatch) => {
    dispatch({ type: CHANGE_PRODUCT, name: 'widget_id', value });
  };
}

export function onDurationOptionRangeVariantSet(value) {
  return (dispatch) => {
    dispatch({ type: CHANGE_PRODUCT, name: 'duration_option_range_variant', value });
  };
}

export function onDurationOptionSet(value) {
  return {
    type: SET_PRODUCT_DURATION_OPTION,
    value,
  };
}

export function onTextColorSet(color) {
  return (dispatch) => {
    dispatch({ type: CHANGE_PRODUCT, name: 'text_color', value: color });
  };
}

export function onBackgroundColorSet(color) {
  return (dispatch) => {
    dispatch({ type: CHANGE_PRODUCT, name: 'background_color', value: color });
  };
}

export function onBorderColorSet(color) {
  return (dispatch) => {
    dispatch({ type: CHANGE_PRODUCT, name: 'border_color', value: color });
  };
}
export function onTitleSet(title) {
  return (dispatch) => {
    dispatch({ type: CHANGE_PRODUCT, name: 'product_title', value: title });
  };
}
export function onExcerptSet(excerpt) {
  return (dispatch) => {
    dispatch({ type: CHANGE_PRODUCT, name: 'excerpt', value: excerpt });
  };
}
export function onImageSet(url) {
  return (dispatch) => {
    dispatch({ type: CHANGE_PRODUCT, name: 'product_image_url', value: url });
  };
}
export function onCheckInTimeSet(value) {
  return (dispatch) => {
    dispatch({ type: CHANGE_PRODUCT, name: 'check_in_time', value });
    dispatch({ type: CHANGE_PRODUCT_ERRORS, key: 'checkIn'})
  };
}
export function onCheckOutTimeSet(value) {
  return (dispatch) => {
    dispatch({ type: CHANGE_PRODUCT, name: 'check_out_time', value });
    dispatch({ type: CHANGE_PRODUCT_ERRORS, key: 'checkOut'})
  };
}
export function onHandleSet(handle) {
  return (dispatch) => {
    dispatch({ type: CHANGE_PRODUCT, name: 'product_handle', value: handle });
  };
}
export function onMindateSet(mindate) {
  return (dispatch) => {
    dispatch({ type: CHANGE_PRODUCT, name: 'mindate', value: mindate });
  };
}
export function onMaxdateSet(maxdate) {
  return (dispatch) => {
    dispatch({ type: CHANGE_PRODUCT, name: 'maxdate', value: maxdate });
  };
}
export function onLeadTimeSet(lead_time) {
  return (dispatch) => {
    dispatch({ type: CHANGE_PRODUCT, name: 'lead_time', value: lead_time });
  };
}
export function onLagTimeSet(lag_time) {
  return (dispatch) => {
    dispatch({ type: CHANGE_PRODUCT, name: 'lag_time', value: lag_time });
  };
}
export function onMinDurationSet(min_duration) {
  return (dispatch) => {
    dispatch({ type: CHANGE_PRODUCT, name: 'min_duration', value: min_duration });
  };
}

export function onMaxDurationSet(value) {
  return (dispatch) => {
    dispatch({ type: CHANGE_PRODUCT, name: 'max_duration', value });
  };
}

export function onTermsSet(terms) {
  return (dispatch) => {
    dispatch({ type: CHANGE_PRODUCT, name: 'terms_attributes', value: terms });
  };
}

export function onTermSet(index, term) {
  return {
    type: SET_PRODUCT_TERM,
    index,
    term,
  };
}

export function onTermAdd(term) {
  return {
    type: ADD_TERM,
    term,
  };
}

export function onCapacityOptionEnable(index, value) {
  return {
    type: CAPACITY_OPTION_ENABLE,
    index,
    value,
  };
}

export function onOptionCapacitiesSet(values) {
  return (dispatch) => {
    dispatch({ type: SET_OPTION_CAPACITIES_ATTRIBUTES, options: values });
  };
}

export function onCapacitySet(value) {
  return (dispatch) => {
    dispatch({ type: CHANGE_PRODUCT, name: 'capacity', value });
  };
}
export function onDurationSet(value) {
  return (dispatch) => {
    dispatch({ type: CHANGE_PRODUCT, name: 'duration', value });
  };
}

export function onCapacityTypeSet(type) {
  return (dispatch) => {
    dispatch({ type: CHANGE_CAPACITY_TYPE, value: type });
  };
}

export function onDurationTypeSet(value) {
  return {
    type: SET_PRODUCT_DURATION_TYPE,
    value,
  };
}

export function onScheduledSet(value) {
  return (dispatch) => {
    dispatch({ type: CHANGE_PRODUCT, name: 'scheduled', value });
  };
}

export function onProductSchedulesSet(value) {
  return {
    type: SET_PRODUCT_SCHEDULES,
    value,
  };
}

export function onProductScheduleUpdateByIndex(index, schedule) {
  return {
    type: SET_PRODUCT_SCHEDULE,
    index,
    schedule,
  };
}

export function onNewProductScheduleAdd(schedule) {
  return {
    type: ADD_PRODUCT_SCHEDULE,
    schedule,
  };
}

export function onVariantsSet(values) {
  return (dispatch) => {
    dispatch({ type: CHANGE_PRODUCT, name: 'variants_attributes', value: values });
  };
}

export function onResourcesSet(values, isCapacityResourceBased) {
  return (dispatch, getState) => {
    const { shop: { resourceQueryBuilderEnabled } } = getState();
    if (resourceQueryBuilderEnabled && isCapacityResourceBased) {
      dispatch({ type: CHANGE_PRODUCT, name: 'resource_capacity_json', value: values });
    } else {
      dispatch({ type: CHANGE_PRODUCT, name: 'resource_constraints_attributes', value: values });
    }
  };
}

export function onLocationsSet(values) {
  return (dispatch) => {
    dispatch({ type: CHANGE_PRODUCT, name: 'product_locations_attributes', value: values });
  };
}

export function onProductSet(product) {
  return {
    type: SET_PRODUCT,
    product,
  };
}

export function onApiProductSet(apiProduct) {
  return {
    type: SET_API_PRODUCT,
    apiProduct,
  };
}

export function onApiBookingSet(apiBooking) {
  return {
    type: SET_API_BOOKING,
    apiBooking,
  };
}

export function onProductAllDaySet(value) {
  return (dispatch) => {
    dispatch({ type: CHANGE_PRODUCT, name: 'all_day', value });
  };
}

export function onDurationEnabledFlagSet(duration_enabled) {
  return {
    type: SET_DURATION_ENABLED_FLAG,
    duration_enabled,
  };
}

export function onActivityDurationVariantsEnabledFlagSet(duration_enabled) {
  return {
    type: SET_ACTIVITY_DURATION_VARIANTS_ENABLED_FLAG,
    duration_enabled,
  };
}

export function onLegacyVariantTimesFlagSet(legacy_variant_times) {
  return {
    type: SET_LEGACY_VARIANT_TIMES_FLAG,
    legacy_variant_times,
  };
}

export function onProductAdd(name) {
  return {
    type: ADD_PRODUCT,
    name,
  };
}

export function onProductUpdate(id) {
  return {
    type: UPDATE_PRODUCT,
    id,
  };
}

export function onProductChange(name, value) {
  return {
    type: CHANGE_PRODUCT,
    name,
    value,
  };
}
export function onProductPropertiesCopy(properties) {
  return {
    type: COPY_PROPERTIES,
    properties,
  };
}

export function onFooSet(options) {
  return {
    type: SET_FOO,
    options,
  };
}

export function onTermEventsSet(events) {
  return {
    type: SET_PRODUCT_TERM_EVENTS,
    events,
  };
}

export function onVisibleInCalendarSet(value) {
  return {
    type: SET_VISIBLE_IN_CALENDAR,
    value,
  };
}

export const fetchProduct = productId => (dispatch) => {
  let id;
  if (productId) {
    id = [productId];
  } else {
    const urlMatch = document.location.pathname.match(/\/admin\/products\/(\d+)\//);
    id = urlMatch && [urlMatch[1]];
  }
  return sdk.getProducts({ id }).then(({ data }) => dispatch(onApiProductSet(data.products[0])));
};

export const fetchBookings = ({ startMin, finishMax }) => dispatch => sdk.getBookings(startMin, finishMax).then(data => dispatch());

export function onProductSubmit(product, callback) {
  let url = '/admin/products';
  let method = 'POST';
  if (product.id) {
    url += `/${product.id}`;
    method = 'PUT';
  }

  return (dispatch) => {
    dispatch({ type: SET_PRODUCT_LOADING, flag: true });
    $.ajax({
      method,
      url,
      dataType: 'json',
      data: {
        product,
      },
    })
      .done((response) => {
        dispatch(onProductSuccessfullyUpdated(response));
        const product = response.product;
        if (callback) { callback(product.product_title) }
        if (window.location.pathname.includes('new')) {
          window.location = `/admin/products/${product.id}/edit?created=true`;
        }
      })
      .fail((jqXHR) => {
        dispatch(onProductFailUpdated(jqXHR));
      });
  };
}

export function onProductSuccessfullyUpdated(response) {
  return (dispatch) => {
    btaa.notify(response.message);
    dispatch({ type: PRODUCT_SUBMITTED, product: response.product });
    dispatch(onSetEditSeasonalRate(false));
  };
}

export function onProductDelete(id, callback) {
  return (dispatch) => {
    dispatch({ type: SET_PRODUCT_LOADING, flag: true });
    $.ajax({
      method: 'DELETE',
      url: `/admin/products/${id}`,
      dataType: 'json',
    })
      .done((response) => {
        btaa.notify(response.message);
        callback();
      })
      .fail((jqXHR, textStatus) => {
        dispatch(onProductFailUpdated(jqXHR));
      });
  };
}

export function onProductFailUpdated(response) {
  return (dispatch) => {
    const responseJSON = response.responseJSON;

    if (responseJSON && responseJSON.message) {
      let message = responseJSON.message;
      let list = Array.isArray(message) ? message.join(', ') : message;
      btaa.notify(list, 'error');
    } else {
      btaa.notify('There was an error saving the product. Please contact support@zetya.com for further assistance.', 'error');
    }
    dispatch({ type: SET_PRODUCT_LOADING, flag: false });
  };
}

export function onProductLoadingSet(flag) {
  return {
    type: SET_PRODUCT_LOADING,
    flag,
  };
}

export function onOptionDurationSet(index, value) {
  return {
    type: SET_PRODUCT_VARIANT_OPTION_DURATION,
    index,
    value,
  };
}

export function onOptionDurationsSet(index, value) {
  return {
    type: SET_PRODUCT_VARIANT_OPTION_DURATIONS,
    index,
    options,
  };
}

export function initProductProperties() {
  return {
    type: INIT_PRODUCT,
  };
}

export function onInputFeedsSet(inputFeeds) {
  return {
    type: SET_INPUT_FEEDS,
    inputFeeds,
  };
}

export function onInputFeedSet(idx, inputFeed) {
  return {
    type: SET_INPUT_FEED,
    idx,
    inputFeed,
  };
}

export function onAddInputFeed(inputFeed) {
  return {
    type: ADD_INPUT_FEED,
    inputFeed
  };
} 

export function onDeleteInputFeed(idx) {
  return {
    type: DELETE_INPUT_FEED,
    idx
  };
}

export function onSetInputFeedName(idx, name) {
  return {
    type: SET_INPUT_FEED_NAME,
    idx,
    name
  };
}

export function onSetInputFeedUrl(idx, url) {
  return {
    type: SET_INPUT_FEED_URL,
    idx,
    url
  };
}

export function onSetInputFeedsValidationErrors(errors) {
  return {
    type: SET_INPUT_FEEDS_VALIDATION_ERRORS,
    errors
  };
}

export function onSetSeasonalRatesValidationErrors(errors) {
  return {
    type: SET_SEASONAL_RATES_VALIDATION_ERRORS,
    errors
  };
}

export function onSetProducHasSeasonalRates(hasSeasonalRates) {
  return {
    type: CHANGE_PRODUCT_HAS_SEASONAL_RATES,
    hasSeasonalRates
  };
}

export function onSetProducSeasonOptionName(seasonOptionName) {
  return {
    type: CHANGE_PRODUCT_SEASON_OPTION_NAME,
    seasonOptionName
  };
}

export function onSetProducSeasonOptionValues(seasonOptionValues) {
  return {
    type: CHANGE_PRODUCT_SEASON_OPTION_VALUES,
    seasonOptionValues
  };
}

export function onSetProducRateOptionName(rateOptionName) {
  return {
    type: CHANGE_PRODUCT_RATE_OPTION_NAME,
    rateOptionName
  };
}

export function onSetProducRateOptionValues(rateOptionValues) {
  return {
    type: CHANGE_PRODUCT_RATE_OPTION_VALUES,
    rateOptionValues
  };
}

export function onSetEditSeasonalRate(editSeasonalRates) {
  return {
    type: SET_EDIT_SEASONAL_RATES,
    editSeasonalRates
  };
}

export function onAddSeasonalRate(seasonalRate) {
  return {
    type: ADD_SEASONAL_RATE,
    seasonalRate
  };
}

export function onDeleteSeasonalRate(season, rate) {
  return {
    type: DELETE_SEASONAL_RATES,
    season,
    rate,
  };
}

export function onSetSeasonalRatePrice(season, rate, price) {
  return {
    type: SET_SEASONAL_RATE_PRICE,
    season,
    rate,
    price
  };
}

export function onSetSeasonalRateStartsAt(season, rate, start) {
  return {
    type: SET_SEASONAL_RATE_STARTS_AT,
    season,
    rate,
    start
  };
}

export function onSetSeasonalRateFinishesAt(season, rate, finish) {
  return {
    type: SET_SEASONAL_RATE_FINISHES_AT,
    season,
    rate,
    finish
  };
}

export function onImportInputFeed(idx, inputFeed, productId) {
  let url = `/admin/products/${productId}/import_feed/${inputFeed.id}`;
  let method = 'POST';

  return (dispatch) => {
    dispatch({ type: SET_PRODUCT_LOADING, flag: true });
    $.ajax({
      method,
      url,
      dataType: 'json'
    })
      .done((response) => {
        dispatch(onInputFeedSet(idx, response.feed));
        dispatch({ type: SET_PRODUCT_LOADING, flag: false });
        btaa.notify(response.message);
      })
      .fail((jqXHR) => {
        dispatch(onProductFailUpdated(jqXHR));
      });
  };
}

export function onFetchProduct(id, callback) {
  let url = `/admin/products/${id}/edit`;
  let method = 'GET';

  return (dispatch) => {
    $.ajax({
      method,
      url,
      cache: false,
      dataType: 'json',
    })
      .done((response) => {
        callback(response)
      })
  };
}